import {
  episodeTextImportCommandKeyExpressionAnxiousValue,
  episodeTextImportCommandKeyStepChatValue,
  episodeTextImportCommandKeyStepChoiceValue,
  episodeTextImportCommandKeyGotoValue,
  episodeTextImportCommandKeyLocationValue,
  episodeTextImportCommandKeyStepReactValue,
  episodeTextImportCommandKeyStepThinkValue,
  EpisodeTextImportCommandKeyValue,
  episodeTextImportCommandKeyExpressionBlushValue,
  episodeTextImportCommandKeyExpressionBoredValue,
  episodeTextImportCommandKeyExpressionDelightValue,
  episodeTextImportCommandKeyExpressionDisgustValue,
  episodeTextImportCommandKeyExpressionFlirtingValue,
  episodeTextImportCommandKeyExpressionHappyValue,
  episodeTextImportCommandKeyExpressionNeutralValue,
  episodeTextImportCommandKeyExpressionRageValue,
  episodeTextImportCommandKeyExpressionSadValue,
  episodeTextImportCommandKeyExpressionScaredValue,
  episodeTextImportCommandKeyExpressionShockValue,
  episodeTextImportCommandKeyExpressionSmileValue,
  episodeTextImportCommandKeyExpressionThinkingValue,
  episodeTextImportCommandKeyExpressionWickedValue,
  episodeTextImportCommandKeyStepRememberValue,
  episodeTextImportCommandKeyStepRandomValue,
  episodeTextImportCommandKeyStepCheckValue,
  episodeTextImportCommandKeyPremiumAnswerValue,
  episodeTextImportCommandKeyBonusContentValue,
  episodeTextImportCommandKeyEndingContentValue,
  episodeTextImportCommandKeyReqValue,
  episodeTextImportCommandKeyStepVideoValue,
  episodeTextImportCommandKeyStepAchieveValue,
} from './episodeTextImportCommandKeyValues';
import { EpisodeTextColumnKey } from './episodeTextImportTypes';

export enum EpisodeTextImportCommandKey {
  Goto = 'goto',
  Location = 'location',
  Background = 'background',
  StepChoice = 'choice',
  StepChat = 'chat',
  StepThink = 'thoughtful',
  StepReact = 'react',
  StepRemember = 'remember',
  StepRandom = 'random',
  StepCheck = 'check',
  StepEnding = 'ending',
  ExpressionAnxious = 'anxious',
  ExpressionBlush = 'blush',
  ExpressionBored = 'bored',
  ExpressionDelight = 'delight',
  ExpressionDisgust = 'disgust',
  ExpressionFlirting = 'flirting',
  ExpressionHappy = 'happy',
  ExpressionNeutral = 'neutral',
  ExpressionRage = 'rage',
  ExpressionSad = 'sad',
  ExpressionScared = 'scared',
  ExpressionShock = 'shock',
  ExpressionSmile = 'smile',
  ExpressionThinking = 'thinking',
  ExpressionWicked = 'evil',
  PremiumAnswer = 'premium',
  BonusContent = 'bonusContent',
  StepReq = 'req',
  StepVideo = 'video',
  StepAchieve = 'achieve',
}

export type TEpisodeTextImportCommandValue = Map<EpisodeTextColumnKey, string[]>;

export type TEpisodeTextImportCommands = Map<EpisodeTextImportCommandKey, TEpisodeTextImportCommandValue>;

export const EpisodeTextImportCommands: Record<EpisodeTextImportCommandKey, EpisodeTextImportCommandKeyValue[]> = {
  [EpisodeTextImportCommandKey.Background]: [
    { pattern: /(#BACKGROUND-JSON)\s+("(?:\\.|[^"\\])*")/i, scope: [EpisodeTextColumnKey.Description] },
    { pattern: /(#BACKGROUND)(?:[:\s]+)?([^#]*)/i, scope: [EpisodeTextColumnKey.Description] },
  ],
  [EpisodeTextImportCommandKey.Goto]: episodeTextImportCommandKeyGotoValue,
  [EpisodeTextImportCommandKey.Location]: episodeTextImportCommandKeyLocationValue,
  [EpisodeTextImportCommandKey.StepChoice]: episodeTextImportCommandKeyStepChoiceValue,
  [EpisodeTextImportCommandKey.StepChat]: episodeTextImportCommandKeyStepChatValue,
  [EpisodeTextImportCommandKey.StepThink]: episodeTextImportCommandKeyStepThinkValue,
  [EpisodeTextImportCommandKey.StepReact]: episodeTextImportCommandKeyStepReactValue,
  [EpisodeTextImportCommandKey.ExpressionAnxious]: episodeTextImportCommandKeyExpressionAnxiousValue,
  [EpisodeTextImportCommandKey.ExpressionBlush]: episodeTextImportCommandKeyExpressionBlushValue,
  [EpisodeTextImportCommandKey.ExpressionBored]: episodeTextImportCommandKeyExpressionBoredValue,
  [EpisodeTextImportCommandKey.ExpressionDelight]: episodeTextImportCommandKeyExpressionDelightValue,
  [EpisodeTextImportCommandKey.ExpressionDisgust]: episodeTextImportCommandKeyExpressionDisgustValue,
  [EpisodeTextImportCommandKey.ExpressionFlirting]: episodeTextImportCommandKeyExpressionFlirtingValue,
  [EpisodeTextImportCommandKey.ExpressionHappy]: episodeTextImportCommandKeyExpressionHappyValue,
  [EpisodeTextImportCommandKey.ExpressionNeutral]: episodeTextImportCommandKeyExpressionNeutralValue,
  [EpisodeTextImportCommandKey.ExpressionRage]: episodeTextImportCommandKeyExpressionRageValue,
  [EpisodeTextImportCommandKey.ExpressionSad]: episodeTextImportCommandKeyExpressionSadValue,
  [EpisodeTextImportCommandKey.ExpressionScared]: episodeTextImportCommandKeyExpressionScaredValue,
  [EpisodeTextImportCommandKey.ExpressionShock]: episodeTextImportCommandKeyExpressionShockValue,
  [EpisodeTextImportCommandKey.ExpressionSmile]: episodeTextImportCommandKeyExpressionSmileValue,
  [EpisodeTextImportCommandKey.ExpressionThinking]: episodeTextImportCommandKeyExpressionThinkingValue,
  [EpisodeTextImportCommandKey.ExpressionWicked]: episodeTextImportCommandKeyExpressionWickedValue,
  [EpisodeTextImportCommandKey.StepRemember]: episodeTextImportCommandKeyStepRememberValue,
  [EpisodeTextImportCommandKey.StepRandom]: episodeTextImportCommandKeyStepRandomValue,
  [EpisodeTextImportCommandKey.StepCheck]: episodeTextImportCommandKeyStepCheckValue,
  [EpisodeTextImportCommandKey.PremiumAnswer]: episodeTextImportCommandKeyPremiumAnswerValue,
  [EpisodeTextImportCommandKey.BonusContent]: episodeTextImportCommandKeyBonusContentValue,
  [EpisodeTextImportCommandKey.StepEnding]: episodeTextImportCommandKeyEndingContentValue,
  [EpisodeTextImportCommandKey.StepReq]: episodeTextImportCommandKeyReqValue,
  [EpisodeTextImportCommandKey.StepVideo]: episodeTextImportCommandKeyStepVideoValue,
  [EpisodeTextImportCommandKey.StepAchieve]: episodeTextImportCommandKeyStepAchieveValue,
};
